<template>
  <div class="extra-block">
    <h4>
      <div class="round-icon">
        <i class="bi bi-rocket-takeoff" />
      </div>
      Vous avez besoin de plus d'évaluations ?
    </h4>
    <p>
      Contactez notre équipe pour bénéficier d’un accompagnement personnalisé
      pour votre organisation.
    </p>
    <div class="dots-container">
      <div class="dots-item" v-for="(item, index) in state.dots" :key="index">
        <div class="round-icon">
          <i class="bi bi-check" />
        </div>
        {{ item }}
      </div>
    </div>
    <Button
      class="primary icon sm"
      label="Prendre contact avec l’équipe Yuzu"
      icon="bi-chevron-right"
      @click="emits('close'), $router.push({ name: 'contact' })"
    />
  </div>
  <h3 class="title-block">Les questions fréquemment posées</h3>
  <div class="faq-wrapper">
    <div v-for="(item, index) in state.faq" :key="index" class="faq-item">
      <div
        class="inner"
        @click="state.faqItemOpen = state.faqItemOpen === index ? null : index"
      >
        <p class="question">{{ item.question }}</p>
        <i
          class="bi bi-chevron-up"
          :class="{ up: state.faqItemOpen === index }"
        />
      </div>
      <transition name="fade">
        <p v-if="state.faqItemOpen === index" class="response">
          {{ item.response }}
        </p>
      </transition>
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";

const emits = defineEmits(["close"]);

const state = reactive({
  faqItemOpen: null,
  faq: [
    {
      question: "Qu’est-ce qu’une évaluation ?",
      response:
        "Une évaluation correspond à la passation de tous les tests Yuzu par un talent.",
    },
    {
      question: "Qu'est-ce qu'un utilisateur ?",
      response:
        "Un utilisateur est un compte recruteur Yuzu relié à votre organisation, il permet à vos collaborateurs de consulter vos campagnes et d'y ajouter de nouveaux talents.",
    },
    {
      question:
        "Faut-il jouer aux jeux vidéo pour passer une évaluation Yuzu ?",
      response:
        "Non ! Les évaluations Yuzu sont conçues pour s'adapter à tous les types de public et, en particulier, aux personnes non habituées aux jeux vidéo.",
    },
    {
      question:
        "Un équipement particulier est-il requis pour passer une évaluation Yuzu ?",
      response:
        "Un ordinateur et une connexion internet fiable sont les seuls éléments nécessaires pour passer une évaluation Yuzu.",
    },
    {
      question:
        "Que se passe-t-il si un talent ne termine pas son évaluation ?",
      response:
        "Si un talent ne termine pas son évaluation, vous pouvez demander un remboursement du crédit utilisé à l'équipe Yuzu.",
    },
  ],
  dots: [
    "Tarif préférenciel",
    "Nombre d'utilisateurs illimité",
    "Accès illimité à toutes les fonctionnalités",
    "Nombre d’espaces illimité",
  ],
});
</script>
